import { render, staticRenderFns } from "./SGPFormSelectComponent.vue?vue&type=template&id=32075e2e"
import script from "./SGPFormSelectComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormSelectComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormSelectComponent.vue?vue&type=style&index=0&id=32075e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports